export default __webpack_public_path__ + "static/media/file_ico.2bf3bbc1.svg";